import Dashboard from '../containers/dashboard'
import CustomerCompanyMoneyMovementsManagement from '../containers/customer-company-money-movements-management'

const CustomerCompanyMoneyMovements = () => {
  return (
    <Dashboard>
      <CustomerCompanyMoneyMovementsManagement />
    </Dashboard>
  )
}

export default CustomerCompanyMoneyMovements
